module.exports = {
  Scale: require('./scale'),
  Coord: require('./coord'),
  Axis: require('./axis'),
  Guide: require('./guide'),
  Legend: require('./legend'),
  Tooltip: require('./tooltip'),
  Event: require('./event')
};


//////////////////
// WEBPACK FOOTER
// ./src/chart/controller/index.js
// module id = 166
// module chunks = 0 1 2